/* src/app/components/analytics/search-report/search-report-queries/search-report-queries.component.scss */
table[mat-table] th[mat-header-cell] {
  font-weight: 500;
}
table[mat-table] th[mat-header-cell]:not(:first-of-type) {
  padding: 2px;
}
mat-list-item:before {
  background-color: none;
  background: none;
}
/*# sourceMappingURL=search-report-queries.component.css.map */
